import React from 'react';
import { UserPlus, UserCheck, Clock, Check } from 'lucide-react';
import { FriendshipState, TEAM_FRIEND_LABELS } from '@radevents/shared';

export default function TeamFriendButton({ state, name, busy, onClick }: { state: FriendshipState; name: string; busy?: boolean; onClick: () => void }) {
  if (state === 'BLOCKED') return null;
  const Icon = state === 'FRIEND' ? UserCheck : state === 'OUTGOING' ? Clock : state === 'INCOMING' ? Check : UserPlus;
  const label = `${TEAM_FRIEND_LABELS[state]}: ${name}`;
  if (state === 'FRIEND') return <span className="team-friend-icon" role="img" aria-label={label} title={label}><Icon size={19} aria-hidden /></span>;
  return <button type="button" className="team-friend-icon" disabled={busy} onClick={onClick} aria-label={label} title={label}><Icon size={19} aria-hidden /></button>;
}
